<template>
    <v-list nav dense>
        <template>
            <v-list-item link router to="/home" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-home</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('inicio') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <!-- Loading areas -->
            <div v-if="loadingAreas" class="text-center py-2">
                <v-progress-circular indeterminate color="white" size="20"></v-progress-circular>
            </div>

            <!-- Grupos dinámicos por área -->
            <v-list-group
                v-for="area in areas"
                :key="area.id"
                no-action
                color="white"
                class="menu-group"
            >
                <template v-slot:activator>
                    <v-list-item-action>
                        <v-icon :color="area.color || 'white'">mdi-map-marker-radius</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ area.name }}</v-list-item-title>
                    </v-list-item-content>
                </template>

                <!-- Check-in / Check-out -->
                <v-list-item
                    link
                    router
                    :to="`/sports-area/${area.id}/checkin`"
                    class="list"
                    active-class="white black--text"
                >
                    <v-list-item-action>
                        <v-icon>mdi-account-check</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('checkin_checkout') || 'Check-in / Checkout' }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>

            <!-- Sin áreas -->
            <div v-if="!loadingAreas && areas.length === 0" class="caption px-4 py-2" style="color: rgba(255,255,255,0.6);">
                {{ $t('no_areas_found') || 'Sin áreas registradas' }}
            </div>

            <v-divider class="my-2" style="border-color: rgba(255,255,255,0.2);"></v-divider>

            <v-list-item link router to="/notices" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-bullhorn</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Notices') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link router to="/settings" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('configuracion') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link router to="/ayuda" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-help-circle</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Ayuda') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-list>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters, mapState } from 'vuex'

const API_BASE_URL = 'https://clubtest.intrare.app'

export default {
  name: 'sports_admin',
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language'])
  },
  data: () => ({
    areas: [],
    loadingAreas: false
  }),
  created () {
    this.loadAreas()
  },
  methods: {
    async loadAreas () {
      this.loadingAreas = true
      try {
        const response = await axios({
          method: 'get',
          url: `${API_BASE_URL}/area/`,
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        const allAreas = response.data || []
        // Filter ONLY Gimnasio and Natacion/Alberca as requested
        this.areas = allAreas.filter(a => {
          const name = (a.name || '').toLowerCase()
          return name.includes('gimnasio') || name.includes('nataci') || name.includes('alberca') || name.includes('piscina') || name.includes('gym')
        })
      } catch (error) {
        console.error('Error loading areas:', error)
      } finally {
        this.loadingAreas = false
      }
    }
  }
}
</script>

<style scoped>
.list {
    margin: 2px 8px !important;
    border-radius: 8px !important;
    transition: all 0.2s ease;
}

.list:hover {
    background: rgba(255, 255, 255, 0.15) !important;
}

.menu-group {
    margin: 4px 8px !important;
    border-radius: 8px !important;
}

.menu-group:hover {
    background: rgba(255, 255, 255, 0.1) !important;
}
</style>
